import { PanelStore } from '../interfaces';

export namespace PayoutsSelectors {
  export const getLoading = (state: PanelStore.RootState) => {
    return state.payouts.loading;
  };
  export const getError = (state: PanelStore.RootState) => {
    return state.payouts.error;
  };
  export const getAllPayouts = (state: PanelStore.RootState) => {
    return state.payouts.allPayouts;
  };
  export const getRequestPayout = (state: PanelStore.RootState) => {
    return state.payouts.requestPayout;
  };
  export const getPayoutDetail = (state: PanelStore.RootState) => {
    return state.payouts.payoutDetail;
  };
  export const getExport = (state: PanelStore.RootState) => {
    return state.payouts.export;
  };
  export const getExportType = (state: PanelStore.RootState) => {
    return state.payouts.exportType;
  };
  export const getCreatePayout = (state: PanelStore.RootState) => {
    return state.payouts.createPayout;
  };
  export const getPayoutContacts = (state: PanelStore.RootState) => {
    return state.payouts.createPayout.contacts;
  };
  export const getPayoutContactsList = (state: PanelStore.RootState) => {
    return state.payouts.contactsList;
  };
  export const getContactsExport = (state: PanelStore.RootState) => {
    return state.payouts.contactsExport;
  };
  export const getPartialValidation = (state: PanelStore.RootState) => {
    return state.payouts.createPayout.partialValidation;
  };

  export const getVerifyOtpConfigured = (state: PanelStore.RootState) => {
    if (!state.payouts.createPayout.verifyOtpConfigured.success) {
      return true;
    }

    return state.payouts.createPayout.verifyOtpConfigured.otpConfigured;
  };
}
